<template>
  <section>
    <v-card>
      <v-toolbar dense dark color="primary">Materials</v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="3" v-for="item in materials" :key="item.id" class="justify-center">
            <v-card>
              <v-list-item :disabled="!item.google_view_link" :href="item.google_view_link" target="_blank">
                <v-list-item-avatar tile size="50">
                  <img :src="`/img/google/${getIcon(item)}.png`" alt="">
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

<!--    <v-dialog fullscreen hide-overlay v-model="selected_item_dialog">-->
<!--      <v-card>-->
<!--        <v-toolbar dense dark color="primary">-->
<!--          <v-btn icon dark @click="closeSelectedItemDialog">-->
<!--            <v-icon>mdi-close</v-icon>-->
<!--          </v-btn>-->
<!--          <v-toolbar-title>Settings</v-toolbar-title>-->
<!--        </v-toolbar>-->


<!--        <template v-if="selected_item">-->
<!--          <iframe width="100%" height="1000" :src="`${selected_item.google_view_link}?embedded=true`" frameborder="0"-->
<!--                  allowfullscreen-->
<!--          ></iframe>-->
<!--        </template>-->
<!--      </v-card>-->
<!--    </v-dialog>-->
  </section>
</template>

<script>
export default {
  name: 'materials-viewer',
  props: {
    items: {
      type: Array,
      default: Array,
    }
  },
  data: () => ({
    mimetypes: [
      {value: 'application/vnd.google-apps.document', text: 'Document', icon: 'document'},
      {value: 'application/vnd.google-apps.drawing', text: 'Drawing', icon: 'drawing'},
      {value: 'application/vnd.google-apps.form', text: 'Form', icon: 'form'},
      {value: 'application/vnd.google-apps.presentation', text: 'Presentation', icon: 'presentation'},
      {value: 'application/vnd.google-apps.spreadsheet', text: 'Sheets', icon: 'spreadsheet'},
      // {value: 'application/vnd.google-apps.photo', text: 'Photo', icon: 'photo'},
      // {value: 'application/vnd.google-apps.video', text: 'video', icon: 'video'},
    ],
    selected_item: null,
    selected_item_dialog: false,
  }),
  computed: {
    materials: function () {
      let materials = []

      if(this.profile_type === 'tutoringSolicitor' || this.profile_type === 'interviewer') {
        materials.push(... this.items)
      } else {
        let filtered = this.items.filter(item => item.student_can_view === true)
        materials.push(...filtered)
      }

      return materials
    }
  },
  methods: {
    getIcon(material) {
      if(material.google_mimetype) {
        let mimetype = this.mimetypes.find(item => item.value === material.google_mimetype)
        if(mimetype) return mimetype.icon
      }
      return null
    },
    openSelectedItemDialog(item){
      this.selected_item = item
      this.selected_item_dialog = true
    },
    closeSelectedItemDialog(){
      this.selected_item_dialog = false
      this.selected_item = null
    }
  }
}
</script>